import { useContext, useState } from "react";
import { xs_isMobile } from "../..";
import { BetslipContext } from "../../data/betslip/BetslipConf";
import { UserContext } from "../../data/betslip/UserConf";
import { classIf, formatDate, getConfiguration, getCurrencyValue, oddToString } from "../../data/utils";
import { getLabel } from "../../InitData";
import Img from "../Img";

function WageringSection(props) {
	const userContext = useContext(UserContext);
	const user = userContext.getUser();
	const betslipContext = useContext(BetslipContext);
	const betOptionsData = betslipContext.getBetOptionsData();	
	const wagerData = !betOptionsData? {funbonuses: [], freebets : [], realMoneyAmount : 0} : betOptionsData;
	function toggleWageringRows(){
		if(wagerData.funbonuses.length > 0 || wagerData.freebets.length > 0){
			if(betslipContext.betOptionsSectionHasToBeShowed){
				betslipContext.hideBetOptions();
			}
			else{
				betslipContext.showBetOptions();
			}			
		}
	}
	
	let wageringNumber = 0;
   	if(user?.logged){
   		wageringNumber = user.freebetCount + user.funbonusCount;
   	}	
	if(!wageringNumber){
		return null;
	}
    let wageringMessage = null;
	if(user.freebetCount > 0 && user.funbonusCount == 0){
		wageringMessage = getLabel('freebet.enabled');
	}
	else if(user.freebetCount == 0 && user.funbonusCount > 0){
		wageringMessage = getLabel('funbonus.enabled');
	}
	else if(user.freebetCount > 0 && user.funbonusCount > 0){
		wageringMessage = getLabel('freebet_funbonus.enabled');
	}
	
	const correctContainer = betslipContext.getCurrentContainer() !== 'systembets';
	return <div className="b_21">
		<div className="b_21_1" onClick={toggleWageringRows}>
			{
				(wagerData.funbonuses.length > 0 || wagerData.freebets.length > 0) && <TicketIcon wageringNumber={wageringNumber} />	
			}
			<div className="b_21_1_2"> {wageringMessage} </div>
			{
				(wagerData.funbonuses.length > 0 || wagerData.freebets.length > 0) &&
				<Img className="b_3_1" src="icon_chevron.svg" height="24px" width="24px" data-rotate={!betslipContext.betOptionsSectionHasToBeShowed? '' : '180'} />
			}
			{
				wagerData.funbonuses.length === 0 && wagerData.freebets.length === 0 && 
				<div>
					{!correctContainer? "" : getLabel('carrello.error.no_selections')}
				</div>
			}
		</div>
		{betslipContext.betOptionsSectionHasToBeShowed && <WageringRows wagerData={wagerData} />}
	</div>
}

function WageringRows(props){
	const wagerData = props.wagerData;
	return <div className="b_21_2">
		{
			wagerData.freebets.length > 0 &&
			<div className="b_21_2_1">
			 {
				 wagerData.freebets.map(wageringDataRow => {
					const reactKey = `freebet-row-${wageringDataRow.id_bonus}`;
					return <WageringRow key={reactKey} isFreebet={true} isFunbonus={false} wageringDataRow={wageringDataRow} />
				})
			}	
			</div>
		}
		{
			wagerData.funbonuses.length > 0 &&
			<div className="b_21_2_1">
			 {
				 wagerData.funbonuses.map(wageringDataRow => {
					const reactKey = `funbonus-row-${wageringDataRow.id_bonus}`;
					return <WageringRow key={reactKey} isFreebet={false} isFunbonus={true} wageringDataRow={wageringDataRow} />
				})
			}	
			</div>
		}
	</div>
}

function WageringRow(props){
	const wageringDataRow = props.wageringDataRow;
	const betslipContext = useContext(BetslipContext) ;
	const betOptionsSelection = betslipContext.getBetOptionsSelection();
    const conf = getConfiguration();
    const nDec = conf.cs.nd;
    const mult = conf.cs.m;
    const currency = conf.cs.ct;
    const [detailsShown, setDetailsShown] = useState(false);
    function toggle(){
    	setDetailsShown(!detailsShown);
    }
    //debugger;
    let amountLabel = null;
    if(props.isFunbonus){
    	amountLabel = xs_isMobile? getLabel('betslip.fun_bonus.remaining_balance') : getLabel('carrello.fun_bonus.remaining_balance');
    }
    else{
    	amountLabel = xs_isMobile? getLabel('betslip.freebet.total_amount') : getLabel('carrello.freebet.total_amount');
    }
    const selected = betOptionsSelection?.type === wageringDataRow.type && betOptionsSelection?.value === wageringDataRow.id_bonus;
    function toggleSelection(){
    	if(selected){
    		betslipContext.setRealMoney();
    	}
    	else {
	    	betslipContext.setBetOptionsSelection(wageringDataRow.id_bonus, wageringDataRow.type);
    	}
    }
	return <div className="b_21_2_1_1">
		<div className={"b_21_2_1_1_1"  + classIf(selected, 'active')} onClick={toggleSelection}>
			<div className="b_17"></div>
			<div>
				{props.isFreebet? getLabel('mybets.freebet') : getLabel('mybets.funbonus')} - {getCurrencyValue(wageringDataRow.importo, mult, nDec, currency)}
			</div>
			<div className="b_21_2_1_1_1_1" onClick={toggle}>
				{getLabel('mybets.dettagli')}
				<Img className="chevron" src="icon_chevron.svg" height="12px" width="12px" data-rotate={!detailsShown? '' : '180'} />
			</div>
		</div>
		{
		detailsShown && <div className="b_21_2_1_1_2"> 
			<div className="row"> 
				<div className="title"> ID </div>
				<div>{wageringDataRow.id_bonus}</div>
			</div>
			{
				wageringDataRow.data_fine_raccolta &&
				<div className="row"> 
					<div className="title"> {getLabel('wagering.expire_date')} </div>
					<div>{formatDate(wageringDataRow.data_fine_raccolta).formatted}</div>
				</div>
			}
			<div className="row"> 
				<div className="title"> {amountLabel} </div>
				<div>{getCurrencyValue(wageringDataRow.importo, mult, nDec, currency)}</div>
			</div>
			{wageringDataRow.rollover && props.isFunbonus &&
					<div className="row">
						<div className="title">{getLabel('wagering.rollover')}</div>
						<div>{wageringDataRow.rollover}</div>
					</div>				
				}
				{wageringDataRow.json_raccolta?.sport?.min_eve && wageringDataRow.json_raccolta.sport.min_eve > 1 &&
					<div className="row">
						<div className="title">{getLabel("wagering.label_min_selections", "Min. selections")}</div>
						<div>{wageringDataRow.json_raccolta.sport.min_eve}</div>
					</div>				
				}
				{wageringDataRow.json_raccolta?.sport?.tot_odd > 100 &&
					<div className="row">
						<div className="title">{getLabel("wagering.label_min_tot_odd", "Min. total odds")}</div>
						<div>{oddToString(wageringDataRow.json_raccolta.sport.tot_odd)}</div>
					</div>				
				}
				{wageringDataRow.json_raccolta?.sport?.min_odd > 100 &&
					<div className="row">
						<div className="title">{getLabel("wagering.label_min_tot_odd_per_sel", "Min. selection total odds")}</div>
						<div>{oddToString(wageringDataRow.json_raccolta.sport.min_odd)}</div>
					</div>				
				}
				{wageringDataRow.min_bet && props.isFunbonus &&
					<div className="row">
						<div className="title">{getLabel('betslip.fun_bonus.min')}</div>
						<div>{getCurrencyValue(wageringDataRow.min_bet, mult, nDec, currency)}</div>
					</div>				
				}
				{wageringDataRow.max_bet && props.isFunbonus &&
					<div className="row">
						<div className="title">{getLabel('betslip.fun_bonus.max')}</div>
						<div>{getCurrencyValue(wageringDataRow.max_bet, mult, nDec, currency)}</div>
					</div>				
				}
				{wageringDataRow.json_raccolta?.sport?.prematch !== null &&
					<div className="row">
						<div className="title">{getLabel('menu.prematch')}</div>
						<div>{wageringDataRow.json_raccolta.sport.prematch? getLabel('general.yes') : getLabel('general.no')}</div>
					</div>				
				}
				{wageringDataRow.json_raccolta?.sport?.live !== null &&
					<div className="row">
						<div className="title">{getLabel('menu.live')}</div>
						<div>{wageringDataRow.json_raccolta.sport.live? getLabel('general.yes') : getLabel('general.no')}</div>
					</div>				
				}
				{wageringDataRow.json_raccolta?.sport?.two_way_market !== null &&
					<div className="row">
						<div className="title">{getLabel("wagering.label_two_way_market", "Market with two draws and DC")}</div>
						<div>{wageringDataRow.json_raccolta.sport.two_way_market? getLabel('general.yes') : getLabel('general.no')}</div>
					</div>				
				}
				{wageringDataRow.data_fine_raccolta && 
					<div className="disclaimer">
						{getLabel('wagering.max_date_error').replaceAll('{{DATE}}', formatDate(wageringDataRow.data_fine_raccolta).formatted)} 
					</div>	
				}

		</div>
		}
	</div>
}

function TicketIcon(props){
	return <>
		<span className="absolute-dot left-border"> </span> 
		<div className="b_21_1_1"> {props.wageringNumber} </div> 
		<span className="absolute-dot right-border"> </span>	
	</>	
}
export default WageringSection;